import _memoize from 'lodash/memoize';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { PRIMARY, CLOUD_NORMAL, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { cacheResolver, makeDefaultStylingContext } from '../../utils/style';
import {
  RADIUS,
  BACKGROUND_UNFOCUSED_OPACITY,
  ICON_BACKGROUND_UNFOCUSED_OPACITY,
  UNFOCUSED_FONT,
  FOCUSED_FONT,
} from './customer/default/keyItem.constants';

export const defaultContext = makeDefaultStylingContext();

const BORDER_RADIUS = RADIUS;

export const KEY_HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const KEY_WIDTH = {
  [HD]: 48,
  [FULL_HD]: 72,
};

export const PICTO_DIMENSIONS = {
  [HD]: {
    width: 24,
    height: 24,
  },
  [FULL_HD]: {
    width: 36,
    height: 36,
  },
};

export const KEYS_GAP = 1;

export const SPECIAL_INDICATOR_RADIUS = 3;

export const SPECIAL_INDICATOR_OFFSET_BOTTOM = {
  [HD]: 2,
  [FULL_HD]: 4,
};

export const SPECIAL_INDICATOR_SIZE = {
  [HD]: 4,
  [FULL_HD]: 6,
};

export const buttonColor = {
  backgroundFocused: makeThemeColor(PRIMARY),
  innerElementUnFocused: makeThemeColor(PRIMARY),
  innerElementFocused: makeThemeColor(TERTIARY),
  specialIndicator: makeThemeColor(CLOUD_NORMAL),
  backgroundUnFocused: makeThemeColor(PRIMARY, BACKGROUND_UNFOCUSED_OPACITY),
  iconBackgroundUnFocused: makeThemeColor(PRIMARY, ICON_BACKGROUND_UNFOCUSED_OPACITY),
};

export const getBasicIconViewBox = _memoize(screenSize => ({
  h: PICTO_DIMENSIONS[screenSize].height,
  w: PICTO_DIMENSIONS[screenSize].width,
}));

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;

  return {
    Button: {
      rect: true,
      w: KEY_WIDTH[screenSize],
      h: KEY_HEIGHT[screenSize],
      color: buttonColor.backgroundUnFocused[colorMode],
      shader: {
        radius: BORDER_RADIUS,
      },
      SpecialIndicator: {
        rect: true,
        w: SPECIAL_INDICATOR_SIZE[screenSize],
        h: SPECIAL_INDICATOR_SIZE[screenSize],
        x: KEY_WIDTH[screenSize] / 2 - SPECIAL_INDICATOR_SIZE[screenSize] / 2,
        y: KEY_HEIGHT[screenSize] - SPECIAL_INDICATOR_SIZE[screenSize] * 2,
        color: buttonColor.specialIndicator[colorMode],
        shader: {
          radius: SPECIAL_INDICATOR_RADIUS,
        },
      },
    },
  };
};

export const getStateLetterStyles = _memoize(
  ({ screenSize, colorMode }) => ({
    unfocused: {
      ...getFont(FONT[FOCUSED_FONT], screenSize),
      lineHeight: KEY_HEIGHT[screenSize],
      textColor: buttonColor.innerElementUnFocused[colorMode],
    },
    focused: {
      ...getFont(FONT[UNFOCUSED_FONT], screenSize),
      lineHeight: KEY_HEIGHT[screenSize],
      textColor: buttonColor.innerElementFocused[colorMode],
    },
  }),
  cacheResolver,
);

export const getBasicLetter = ({ symbol, screenSize, colorMode }) => ({
  Letter: {
    w: KEY_WIDTH[screenSize],
    h: KEY_HEIGHT[screenSize],
    text: {
      ...getFont(FONT.KINSHASA_1, screenSize),
      lineHeight: KEY_HEIGHT[screenSize],
      textColor: buttonColor.innerElementUnFocused[colorMode],
      textAlign: 'center',
      text: symbol.toUpperCase(),
      verticalAlign: 'middle',
    },
  },
});
